export default __webpack_public_path__ + "static/media/operativeColor.8285aad7.png";